export default "__VITE_ASSET__efb1d5c1__"